"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

require("./EntryComponent.css");

var _excluded = ["mention", "theme", "isFocused", "searchValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EntryComponent = function EntryComponent(props) {
  var mention = props.mention,
      theme = props.theme,
      isFocused = props.isFocused,
      searchValue = props.searchValue,
      parentProps = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", parentProps, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mention-entry " + theme.mentionSuggestionsEntryText
  }, mention.name), " ", /*#__PURE__*/_react["default"].createElement("p", {
    className: "float-right"
  }, /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Badge, {
    variant: mention.type === "event" ? "success" : "info"
  }, mention.type))));
};

var _default = EntryComponent;
exports["default"] = _default;
module.exports = exports.default;